import { useState, useCallback } from 'react';
import quarkusApi from '../../../api/quarkusApi';

export function useDeleteLaboratory() {
  const [isDeleting, setDeleting] = useState(false);

  const remove = useCallback((laboratoryId) => {
    setDeleting(true);
    return quarkusApi
      .delete(`/laboratories/${laboratoryId}`, {
        headers: { Authorization: sessionStorage.getItem('token') },
      })
      .finally(() => setDeleting(false));
  }, []);

  return { remove, isDeleting };
}
